import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ICreategoals } from "../../../Pages/DashboardUserStudent/IDashboardUserStudent";

export const AddCreategoalsSlice = createSlice({
  name: "AddCreategoalsSlice",
  initialState: {} as IReduxState<ICreategoals>,
  reducers: {
    addCreategoals: (state, _: PayloadAction<ICreategoals>) => {
      state.isLoading = true;
    },
    successaddCreategoals: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureaddCreategoals: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearAddCreategoalsResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  addCreategoals,
  failureaddCreategoals,
  successaddCreategoals,
  clearAddCreategoalsResponse,
} = AddCreategoalsSlice.actions;

export default AddCreategoalsSlice.reducer;
